import { Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BulkActionBarProps {
  selectedCount: number;
  managers: { id: string; name: string }[];
  onAssignManager: (managerId: string) => void;
  onSchedulePickup: (date: Date, timeSlot: string) => void;
  onClearSelection: () => void;
}

export const BulkActionBar = ({
  selectedCount,
  managers,
  onAssignManager,
  onClearSelection,
}: BulkActionBarProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-4 px-6 py-4 bg-card border rounded-xl shadow-lg">
        <span className="text-sm font-medium">
          {selectedCount} package{selectedCount > 1 ? "s" : ""} selected
        </span>

        <div className="h-6 w-px bg-border" />

        {/* Assign Manager Dropdown */}
        <Select onValueChange={onAssignManager}>
          <SelectTrigger className="w-[200px] bg-background">
            <Users className="h-4 w-4 mr-2" />
            <SelectValue placeholder="Assign to..." />
          </SelectTrigger>
          <SelectContent className="bg-popover">
            {managers.map((manager) => (
              <SelectItem key={manager.id} value={manager.id}>
                {manager.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Button
          onClick={() => {
            // Assignment happens via the Select onValueChange above
          }}
          disabled
          className="hidden"
        >
          Assign
        </Button>

        <div className="h-6 w-px bg-border" />

        <Button variant="ghost" size="sm" onClick={onClearSelection}>
          Clear
        </Button>
      </div>
    </div>
  );
};
